<template>
  <v-app-bar
    id="core-app-bar"
    absolute
    app
    color="transparent"
    flat
    height="88"
  >
    <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
      <v-btn @click.stop="onClick" text>
        <v-icon>mdi-view-list</v-icon>
        {{ $t("components.vuematerialdashboard.core.appbar.menu") }}
      </v-btn>
      <img
        v-if="!responsive"
        style="vertical-align: middle; height: 50px; margin: 10px"
        :src="require('@/assets/logo.png')"
      />
    </v-toolbar-title>

    <v-spacer />

    <v-toolbar-items>
      <v-row align="center" class="mx-0">
        <v-menu
          bottom
          left
          offset-y
          transition="slide-y-transition"
          v-if="
            isLoggedIn &&
              usr &&
              (role.indexOf('Claims Administrator') > -1 ||
                role.indexOf('Global Support Manager') > -1 ||
                role.indexOf('Broker Support Admin') > -1)
          "
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon color="tertiary">description</v-icon>
              {{
                $t("components.vuematerialdashboard.core.appbar.administration")
              }}
            </v-btn>
          </template>
          <v-list dense expand>
            <v-list-group
              v-if="role.indexOf('Claims Administrator') > -1"
              :value="groups.claims"
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="group-header">
                      {{
                        $t("components.vuematerialdashboard.core.appbar.claims")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item @click="$router.push({ name: 'claimsTable' })">
                <v-list-item-icon>
                  <i class="material-icons">medical_services</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.claims_management'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'claimsPayments' })">
                <v-list-item-icon>
                  <i class="material-icons">attach_money</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.claims_payments'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'claimsReports' })">
                <v-list-item-icon>
                  <i class="material-icons">summarize</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.claims_reports'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'iSeriesClaimsView' })">
                <v-list-item-icon>
                  <i class="material-icons">description</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.i_series_claims'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'guidesView' })">
                <v-list-item-icon>
                  <i class="material-icons">architecture</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.guides')
                  "
                />
              </v-list-item>
            </v-list-group>
            <v-list-group
              v-if="
                role.indexOf('Global Support Manager') > -1 ||
                  role.indexOf('Broker Support Admin') > -1
              "
              :value="groups.users"
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="group-header">
                      {{
                        $t(
                          "components.vuematerialdashboard.core.appbar.roles_and_permissions"
                        )
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                @click="$router.push({ name: 'users' })"
                v-if="
                  role.indexOf('Global Support Manager') > -1 ||
                    role.indexOf('Broker Support Admin') > -1
                "
              >
                <v-list-item-icon>
                  <i class="material-icons">people</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.users')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="$router.push({ name: 'organizations' })"
                v-if="role.indexOf('Global Support Manager') > -1"
              >
                <v-list-item-icon>
                  <i class="material-icons">supervised_user_circle</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('globals.organizations')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="$router.push({ name: 'tags' })"
                v-if="
                  role.indexOf('Global Support Manager') > -1 ||
                    role.indexOf('Broker Support Admin') > -1
                "
              >
                <v-list-item-icon>
                  <i class="material-icons">label</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.tags')
                  "
                />
              </v-list-item>
            </v-list-group>
            <v-list-group
              v-if="
                role.indexOf('Global Support Manager') > -1 ||
                  role.indexOf('Broker Support Admin') > -1
              "
              :value="groups.users"
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="group-header">
                      {{
                        $t(
                          "components.vuematerialdashboard.core.appbar.statements_and_invoices"
                        )
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                @click="$router.push({ name: 'invoicesAdminView' })"
                v-if="
                  role.indexOf('Global Support Manager') > -1 ||
                    role.indexOf('Broker Support Admin') > -1
                "
              >
                <v-list-item-icon>
                  <i class="material-icons">list</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('views.invoices_view.invoices')
                  "
                />
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-menu>
        <v-menu
          bottom
          left
          offset-y
          transition="slide-y-transition"
          v-if="
            isLoggedIn &&
              usr &&
              (role.indexOf('Global Support Manager') > -1 ||
                role.indexOf('Broker Plan Creator') > -1)
          "
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon color="tertiary">build</v-icon>
              {{
                $t("components.vuematerialdashboard.core.appbar.configuration")
              }}
            </v-btn>
          </template>
          <v-list dense expand>
            <v-list-group
              v-if="role.indexOf('Global Support Manager') > -1"
              :value="groups.indexes"
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="group-header">
                      {{
                        $t(
                          "components.vuematerialdashboard.core.appbar.plans_management"
                        )
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                @click="
                  $router.push({
                    name: 'selectBroker',
                    params: { route: 'plans' },
                  })
                "
                v-if="
                  role.indexOf('Global Support Manager') > -1 &&
                    role.indexOf('Broker Plan Creator') > -1
                "
              >
                <v-list-item-icon>
                  <i class="material-icons">file_copy</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('globals.plans')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'plans',
                    params: { broker: usr.profile.brokerid },
                  })
                "
                v-else-if="role.indexOf('Broker Plan Creator') > -1"
              >
                <v-list-item-icon>
                  <i class="material-icons">file_copy</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('globals.plans')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="$router.push({ name: 'insuranceCarriersIndex' })"
              >
                <v-list-item-icon>
                  <i class="material-icons">home_work</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'globals.insurance_carriers'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'claimAdmins' })">
                <v-list-item-icon>
                  <i class="material-icons-outlined">health_and_safety</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.claim_admins_payors'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'underwritersView' })">
                <v-list-item-icon>
                  <i class="material-icons-outlined">verified_user</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.underwriters'
                    )
                  "
                />
              </v-list-item>
              <v-list-item
                @click="$router.push({ name: 'brokersIndex' })"
              >
                <v-list-item-icon>
                  <i class="material-icons">badge</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.getreports.brokers'
                    )
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'selectBroker',
                    params: { route: 'planFeesConfiguration' },
                  })
                "
                v-if="
                  role.indexOf('Global Support Manager') > -1 &&
                    role.indexOf('Broker Plan Creator') > -1
                "
              >
                <v-list-item-icon>
                  <v-icon>list</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.plan_fees_configuration'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'taxes' })">
                <v-list-item-icon>
                  <i class="material-icons">toll</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.taxes')
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'pensionRegulators' })">
                <v-list-item-icon>
                  <i class="material-icons-outlined">balance</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.pension_regulators'
                    )
                  "
                />
              </v-list-item>
            </v-list-group>
            <v-list-group :value="groups.plans">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="group-header">
                      {{
                        $t(
                          "components.vuematerialdashboard.core.appbar.claims"
                        )
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item @click="$router.push({ name: 'benefitsView' })">
                <v-list-item-icon>
                  <v-icon>mdi-tag-heart-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.benefits')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'selectBroker',
                    params: { route: 'planBenefitsRules' },
                  })
                "
                v-if="
                  role.indexOf('Global Support Manager') > -1 &&
                    role.indexOf('Broker Plan Creator') > -1
                "
              >
                <v-list-item-icon>
                  <v-icon>list</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.benefit_claims_rules'
                    )
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'planBenefitsRules',
                    params: { broker: usr.profile.brokerid },
                  })
                "
                v-else-if="role.indexOf('Broker Plan Creator') > -1"
              >
                <v-list-item-icon>
                  <v-icon>list</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.benefit_claims_rules'
                    )
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'selectBroker',
                    params: { route: 'claimsSettings' },
                  })
                "
                v-if="
                  role.indexOf('Global Support Manager') > -1 &&
                    role.indexOf('Broker Plan Creator') > -1
                "
              >
                <v-list-item-icon>
                  <i class="material-icons">settings</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.claims_settings')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'claimsSettings',
                    params: { broker: usr.profile.brokerid },
                  })
                "
                v-else-if="role.indexOf('Broker Plan Creator') > -1"
              >
                <v-list-item-icon>
                  <i class="material-icons">settings</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.claims_settings')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'selectBroker',
                    params: { route: 'sickPaymentSettings' },
                  })
                "
                v-if="
                  role.indexOf('Global Support Manager') > -1 &&
                    role.indexOf('Broker Plan Creator') > -1
                "
              >
                <v-list-item-icon>
                  <i class="material-icons">sick</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.sick_payment_settings')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'sickPaymentSettings',
                    params: { broker: usr.profile.brokerid },
                  })
                "
                v-else-if="role.indexOf('Broker Plan Creator') > -1"
              >
                <v-list-item-icon>
                  <i class="material-icons">sick</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.sick_payment_settings')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'selectBroker',
                    params: { route: 'planGuidesAssignments' },
                  })
                "
                v-if="
                  role.indexOf('Global Support Manager') > -1 &&
                    role.indexOf('Broker Plan Creator') > -1
                "
              >
                <v-list-item-icon>
                  <i class="material-icons">tune</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.plan_guides_assignments')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'planGuidesAssignments',
                    params: { broker: usr.profile.brokerid },
                  })
                "
                v-else-if="role.indexOf('Broker Plan Creator') > -1"
              >
                <v-list-item-icon>
                  <i class="material-icons">tune</i>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.plan_guides_assignments')
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'selectBroker',
                    params: { route: 'planDrugs' },
                  })
                "
                v-if="
                  role.indexOf('Global Support Manager') > -1 &&
                    role.indexOf('Broker Plan Creator') > -1
                "
              >
                <v-list-item-icon>
                  <v-icon>local_hospital</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.plan_drugs_formulary'
                    )
                  "
                />
              </v-list-item>
              <v-list-item
                @click="
                  $router.push({
                    name: 'planDrugs',
                    params: { broker: usr.profile.brokerid },
                  })
                "
                v-else-if="role.indexOf('Broker Plan Creator') > -1"
              >
                <v-list-item-icon>
                  <v-icon>list</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t(
                      'components.vuematerialdashboard.core.appbar.plan_drugs_formulary'
                    )
                  "
                />
              </v-list-item>
              <v-list-item @click="$router.push({ name: 'providersView' })">
                <v-list-item-icon>
                  <v-icon>folder_shared</v-icon>
                </v-list-item-icon>
                <v-list-item-title
                  v-text="
                    $t('components.vuematerialdashboard.core.appbar.providers')
                  "
                />
              </v-list-item>
            </v-list-group>
            
          </v-list>
        </v-menu>
        <v-menu
          bottom
          left
          offset-y
          transition="slide-y-transition"
          v-if="isLoggedIn"
        >
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">{{ user }}</v-btn>
          </template>

          <v-list>
            <v-list-item @click="logout()">
              <v-list-item-title>
                {{ $t("globals.logout") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push({ name: 'myAccount' })">
              <v-list-item-title>
                {{
                  $t("components.vuematerialdashboard.core.appbar.my_account")
                }}
              </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item @click="$router.push({ name: 'myTickets' })">
              <v-list-item-title>
                {{
                  $t("components.vuematerialdashboard.core.appbar.my_tickets")
                }}
              </v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>

        <!-- <v-menu bottom left offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              {{ selectedLang.title }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="entry in languages"
              :key="entry.title"
              @click="changeLocale(entry)"
              :disabled="entry.language === selectedLang.language"
            >
              <v-list-item-title>
                {{ entry.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
      </v-row>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
// Utilities

import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
    usr: undefined,
    selectedLang: {},
    title: null,
    responsive: false,

    newUsersCount: 3,
    alertsCount: 2,
    onlineUsersCount: "1/13",
    tasksCount: 12,
    groups:{
      claims: true,
      users: true,
      plans: true,
      indexes: true
    }
  }
},
  watch: {
    $route(val) {
      this.title = val.name;
    },
    language: {
      handler(v) {
        if (v) {
          this.selectedLang = this.language;
        }
      },
    },
  },

  async mounted() {
    this.usr = await this.getUser();
    this.selectedLang = this.language;
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
  },
  methods: {
    ...mapActions("auth", ["logout", "login", "setUser", "getUser"]),
    ...mapGetters("common", ["plan", "plans"]),
    ...mapActions("common", ["setLanguage"]),

    onClick() {
      this.$emit("toggle-nav");
    },

    changeLocale(locale) {
      this.$vuetify.lang.current = locale.language;
      this.setLanguage(locale);
    },

    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
};
</script>

<style>
/* Fix coming in v2.0.8 */
#core-app-bar {
  width: auto;
}

#core-app-bar a {
  text-decoration: none;
}
.v-list-item__icon {
  margin-right: 5px !important;
}
.group-header {
  /* font-weight: 700!important; */
  font-size: large!important;
}
</style>
